import { render, staticRenderFns } from "./IpcList.vue?vue&type=template&id=44cbc290&"
import script from "./IpcList.vue?vue&type=script&lang=js&"
export * from "./IpcList.vue?vue&type=script&lang=js&"
import style0 from "./IpcList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IpcList.vue"
export default component.exports